'use client';

import React, { useState, useEffect } from 'react';
import { TbCheck as Check, TbShare2 as Share2 } from 'react-icons/tb';

interface BlogShareButtonProps {
  title: string;
  isAr: boolean;
  t: {
    share?: string;
    copied?: string;
  };
}

export default function BlogShareButton({ title, isAr, t }: BlogShareButtonProps) {
  const [copied, setCopied] = useState(false);
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          url: url,
        });
        return;
      } catch (err) {
        // Fallback to copy to clipboard if share gets cancelled or fails
        if ((err as Error).name !== 'AbortError') {
          copyToClipboard();
        }
      }
    } else {
      copyToClipboard();
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <button
      onClick={handleShare}
      className="inline-flex items-center gap-2 px-4 py-2 bg-white/[0.03] hover:bg-white/[0.08] border border-white/10 hover:border-brand-cta/50 rounded-full text-sm font-heading font-semibold text-brand-text/80 hover:text-white transition-all duration-300"
      title={isAr ? 'مشاركة' : 'Share'}
    >
      {copied ? (
        <>
          <Check className="w-4 h-4 text-green-500" />
          <span className="text-green-500">{t.copied || (isAr ? 'تم النسخ' : 'Copied')}</span>
        </>
      ) : (
        <>
          <Share2 className="w-4 h-4 text-brand-cta" />
          <span>{t.share || (isAr ? 'مشاركة' : 'Share')}</span>
        </>
      )}
    </button>
  );
}
